import React from 'react';
import { HeartHandshakeIcon, ShieldCheckIcon, UserRoundIcon, UsersIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { audiences } from '../data/megaPack';
const icons = [UsersIcon, HeartHandshakeIcon, UserRoundIcon, ShieldCheckIcon];
export function ForWho() {
  return <section className="bg-teal-50 py-10 sm:py-20" aria-labelledby="para-quien" data-id="element-118" data-mp="2hctbc1qq6hy6">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-119" data-mp="2mbe5bjfdw5e6">
        <SectionHeading eyebrow="¿Para quién es?" title="Diseñado para vos si querés acompañar mejor a un adulto mayor sin gastar de mas" data-id="element-120" data-mp="2mcxi301tzyb7" />

        <div className="mt-6 grid gap-2.5 sm:mt-12 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4" data-id="element-121" data-mp="2vcubtg32vnd4">
          {audiences.map((item, index) => {
          const Icon = icons[index % icons.length];
          return <article key={item.title} className="flex items-start gap-3 rounded-2xl bg-cream-50 p-4 shadow-card ring-1 ring-teal-900/5 transition-transform duration-150 ease-out active:scale-[0.99] sm:flex-col sm:gap-0 sm:p-6 sm:hover:-translate-y-0.5" data-id="element-122" data-mp="10zcmbnj44gfg" data-mpi={index}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-700 sm:h-11 sm:w-11" data-id="element-123" data-mp="sk6dan59d2fr">
                  <Icon className="h-4 w-4 text-cream-50 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-124" data-mp="jkt2nr5ee7tg" />
                </span>
                <div className="min-w-0" data-id="element-125" data-mp="1gaacmibeyg0y">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 sm:mt-4" data-id="element-126" data-mp="1bbh1gwjln13y">
                    <h3 className="font-display text-sm font-800 leading-snug text-teal-900 sm:text-lg" data-id="element-127" data-mp="17a56sclvbpow">
                      {item.title}
                    </h3>
                    {item.badge ? <span className="rounded-full bg-gold-500 px-2 py-0.5 font-display text-[0.6rem] font-800 uppercase tracking-[0.12em] text-teal-900" data-id="element-128" data-mp="3s0cssharva4a">
                        {item.badge}
                      </span> : null}
                  </div>
                  <p className="mt-1 text-[0.8rem] leading-relaxed text-clay sm:mt-2 sm:text-sm" data-id="element-129" data-mp="3ogvsr2zhhlln">
                    {item.description}
                  </p>
                </div>
              </article>;
        })}
        </div>

        <div className="mx-auto mt-6 flex max-w-xl flex-col items-center rounded-2xl border border-dashed border-teal-700/30 bg-cream-50/60 px-4 py-3.5 text-center sm:mt-10 sm:gap-1 sm:px-6 sm:py-5" data-id="element-130" data-mp="3jiub8mhphuca">
          <p className="font-display text-sm font-700 text-teal-900 sm:text-base" data-id="element-131" data-mp="3aj75xpluw4dy">
            ¿No estás seguro si es para vos?
          </p>
          <p className="text-xs text-clay sm:text-sm" data-id="element-132" data-mp="2vvui1u8ktmke">Tenés 7 días de garantía.</p>
        </div>
      </div>
    </section>;
}